import { FC } from "react";
import { MuiModal } from "../../../../../../components/modal/MuiModal";
import { useSiteCore } from "../../../../../../hooks/useSiteCore";
import { MuiTypography } from "../../../../../../components/typography/MuiTypography";
import { DiscardMessageWrapper } from "../../ClientActivitiesAndDeliverables.style";

interface CancelFieldModalProps {
  showModal: boolean;
  handleModalClose: () => void;
  handlePrimaryButtonClick: () => void;
  cancelMessage?:string;
  title?:string;
  primaryButtonTitle?:string;
}
export const CancelFieldModal: FC<CancelFieldModalProps> = ({
  handleModalClose,
  showModal,
  handlePrimaryButtonClick,
  cancelMessage,
  title,
  primaryButtonTitle
}) => {
  const { commonLabels } = useSiteCore();
  return (
    <MuiModal
      open={showModal}
      onClose={handleModalClose}
      title={title??commonLabels.cancelChanges}
      primaryButtonTitle={primaryButtonTitle??commonLabels.yes}
      secondaryButtonTitle={commonLabels.no}
      onPrimaryButtonClick={handlePrimaryButtonClick}
      onSecondaryButtonClick={handleModalClose}
    >
      <DiscardMessageWrapper>
        <MuiTypography
          id="modal-description"
          variant="h3"
          className="confirm-message"
          data-testid="cancel-field-modal"
        >
        {cancelMessage ?? commonLabels.cancelButtonAlertText}
        </MuiTypography>
      </DiscardMessageWrapper>
    </MuiModal>
  );
};
